import { z } from 'zod';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_OG_TEXT = defineFcm('psf_og_text')
	.asJson(
		z.object({
			enabled: z.boolean().optional(),
			experimentName: z.string().optional(),
		}),
	)
	.withDefault({ enabled: false, experimentName: undefined })
	.toConfig({
		owner: 'squad-platypus',
		scope: ['corgi-front-end', 'corgi-middle-end'],
		context: 'PSF share links (slide-up, /psf/share) and their link previews',
		description: `Gates the OG text experiment. When enabled, PSF share links for variant arms carry an /og/:variant
			path segment so link-preview crawlers render that arm's og:title / og:description. Gates link creation only:
			links already shared keep rendering their arm. To switch the experiment off, set enabled: false rather than
			using Disable.`,
		supportedGroups: { global: true, locales: true, countries: true },
		template: { enabled: true, experimentName: 'psf_og_text_experiment' },
	});
